var _defs, _path, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 32 32",
    sodipodiDocname: "receipt.svg",
    width: 32,
    height: 32,
    inkscapeVersion: "1.0.1 (3bc2e813f5, 2020-09-07)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs39"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style37"
  }, ".cls-1{fill:#999;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title41"
  }, "\xCDcones") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title41"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "matrix(0.39640484,0,0,0.39640484,0.02292913,0.02292908)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 23.712264,16.150619 V 63.55292 c 0,0 3.754589,-6.05548 8.234856,-6.188701 4.480268,-0.13322 9.328631,6.188701 9.328631,6.188701 0,0 4.480267,-6.939581 8.781745,-6.152369 4.301477,0.787213 8.781744,6.152369 8.781744,6.152369 V 16.150619 Z",
    id: "path45"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.363819,
    y1: 32.056576,
    x2: 48.518551,
    y2: 32.105194,
    id: "line49"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.024323,
    y1: 39.835423,
    x2: 48.518551,
    y2: 39.870155,
    id: "line51"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.710953,
    y1: 39.835423,
    x2: 36.183521,
    y2: 39.849316,
    id: "line53"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.024323,
    y1: 44.440228,
    x2: 48.518551,
    y2: 44.474949,
    id: "line55"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.710953,
    y1: 44.440228,
    x2: 36.183521,
    y2: 44.454113,
    id: "line57"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.475353,
    y1: 16.046856,
    x2: 66.420921,
    y2: 16.060055,
    id: "line49-7",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: "1.7206px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.a3c175b359da37ff2ca6a41a774d6c6e.svg";
export { ForwardRef as ReactComponent };